import React from "react";
// import AbstractField from "./Abstract";
import SvgSprite from "championship/src/components/Utils/SvgSprite";

class SelectField extends React.Component{
    render(){
        const that = this
        return (
            <div class="js-select-wrapper">
                <div class="js-select-wrapper-abs">
                    <div class="js-form-field__wrapper">
                        <div class="js-form-field__icon --search">
                            <SvgSprite id="search" section="form"/>
                        </div>
                        <div class="js-form-field__text">
                            <input type="text" class="js-select-title"/>
                            <div type="text" class="js-select-title"></div>
                            <select
                                name={this.props.name}
                                id={this.props.id}
                                required={this.props.required}
                                defaultValue={this.props.initial_value}
                                // value={this.props.value}
                                >
                                {this.props?.items?.map(item => (
                                  <option 
                                    key={item.value} 
                                    value={item.value}
                                    // selected={item.value===this.props.initial_value ? true : undefined}
                                    // selected={item.value==2 ? true : undefined}
                                    // selected
                                >
                                    {item.label}
                                  </option>
                                ))}
                            </select>
                        </div>
                        <div class="js-form-field__icon --arrow">
                            <SvgSprite id="arrow_bottom" section="form"/>
                        </div>
                        <div class="js-form-field__icon --close">
                            <SvgSprite id="close" section="form"/>
                        </div>
                    </div>
                    <div class="js-select-slide">
                        <div class="js-select-list">

                        </div>
                    </div>
                </div>
            </div>
        )
    }
}


export default SelectField